import { render } from "./survey-question.vue?vue&type=template&id=3b8866d4&lang=pug"
import script from "./survey-question.vue?vue&type=script&setup=true&lang=js"
export * from "./survey-question.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__